import { render, staticRenderFns } from "./AdaNotificationHistoriesTable.vue?vue&type=template&id=03b39c72&"
import script from "./AdaNotificationHistoriesTable.vue?vue&type=script&lang=js&"
export * from "./AdaNotificationHistoriesTable.vue?vue&type=script&lang=js&"
import style0 from "./AdaNotificationHistoriesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports